<template>
  <div class="car-display">
    <img class="img-thumbnail" v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( car.CarType.AmazonImage.objectKey ? car.CarType.AmazonImage.objectKey : 'spacer.gif' ) + '?v=' + new Date().getTime()"/>
    <h4>{{ car.CarType.name }}</h4>
  <p>{{ car.name }} (#{{ car.convadisId }} - {{ car.rego }})<br/>
    {{ car.Lot.address }}</p>
    <p><strong>Address:</strong> {{ car.Lot.address }}<br/>
    <strong>Memo:</strong> {{ car.Lot.addressMemo }}<br/>
    <template v-if="car.CarFeatures && car.CarFeatures.length">
      <strong>Features:</strong> <template v-for="feature in car.CarFeatures">
        <i v-if="feature.icon" v-bind:class="'fa ' + feature.icon + ' fa-lg'"></i> {{ feature.name }}
      </template><br/>
    </template>
    <center><img v-bind:src="'https://maps.googleapis.com/maps/api/staticmap?center='+ car.Lot.latitude +','+ car.Lot.longitude +'&zoom=17&size=250x250&maptype=roadmap&markers=color:red%7Clabel:C%7C'+ car.Lot.latitude +','+ car.Lot.longitude +'&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'" alt="Lot Location"></center>
  </div>
</template>

<script>
export default {
  name: 'CarDisplay',
  props: {
    car: {
      type: Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// CarDisplay.vue?258f0467